import { Pipe, PipeTransform, isDevMode } from '@angular/core';
import { AppService } from 'src/app/app.service';

/**
 * 依瀏覽器支援度把圖片路徑改為 webp。
 *
 * ## ⚠️ 只能用在「單一個點」的靜態相對路徑
 *
 * 非 `simple` 模式的實作是 `value.split('.')` 後取 `arr[0]`，
 * 因此任何含多個點的字串都會被截斷：
 *
 * ```text
 * assets/images/home/bear_taps.png      → assets/images/home/bear_taps.webp   ✅
 * https://cdn.example.com/icons/x.png   → https://cdn.webp                    ❌ 整個壞掉
 * ```
 *
 * **不要**把它套在會接到後端回傳網址的綁定上（例如 `swiper-unit` 的
 * `[src]="titleIcon"`，該輸入同時服務 `home.component` 傳入的動態 `item?.icon`）。
 * 完整網址請改走 `simple` 模式，它走的是 query string 而非字串截斷。
 *
 * ## 另一個前提：對應的 .webp 必須存在
 *
 * 本 pipe 不會檢查檔案是否存在。支援 webp 的瀏覽器會直接拿到改寫後的路徑，
 * 檔案沒產生就是 404。`assets/images/home` 目前 8 個 png 只有 4 個有對應 webp。
 */
@Pipe({
  name: 'preferWebp',
})
export class PreferWebpPipe implements PipeTransform {
  constructor(private appService: AppService) {}
  transform(value: string, simple: boolean | string = false): string {
    let v = value ?? '';
    if (simple && v.startsWith('http')) {
      const base = '?q=80';
      const format = '&format=webp';
      const width = typeof simple === 'string' ? '&w=' + simple : '';
      return window.isSupportWebp ? v + base + format + width : v + base + width;
    }
    const arr = v.split('.');
    // 支持webp默认使用webp，要确保该图片的webp格式存在
    if (arr[1] && arr[1] !== 'webp' && window.isSupportWebp) {
      v = `${arr[0]}.webp`;
    }
    // 如果是本地资源，改用 deployUrl 域名
    if (!v.startsWith('http') && !isDevMode()) {
      const deployUrl = this.appService.tenantConfig$.value?.config?.deployUrl || '';
      v = deployUrl + v;
    }
    // 增加版本号
    if (v) {
      v = `${v}?v=${window.version}`;
    }
    return v;
  }
}
